import { useState, type ReactNode } from 'react';
import { ApolloError } from '@apollo/client/errors';
import { Box, Button, IconRefresh16, Spinner, Text } from '@stitch-fix/mode-react';
import { formatMoney } from '@stitch-fix/format';
import { browserLogger } from '../../../utils/loggers/browser';
import { useGetCreditSummaryQuery } from '../graphql/getCreditSummary';
import type { Money } from '../../../types/definitions/vendor/graphql-schema';
const zeroDollars: Money = {
  value: 0,
  currency: 'USD'
};
export const CreditContent = () => {
  const [totalCreditAvailable, setTotalCreditAvailable] = useState(zeroDollars);
  const [renderError, setRenderError] = useState(false);
  const handleQueryError = (err: ApolloError) => {
    setRenderError(true);
    browserLogger({
      level: 'error',
      team: 'incentives',
      message: 'Account Credit page Credit Summary error',
      context: {
        error: err.message
      }
    });
  };
  const {
    loading: creditSummaryLoading,
    refetch
  } = useGetCreditSummaryQuery({
    onCompleted: data => {
      const amount = data.client?.creditSummary.available.totalAmount;
      if (amount) {
        setTotalCreditAvailable(amount);
      }
      setRenderError(false);
    },
    onError: handleQueryError
  });
  let totalCreditNode: ReactNode = null;
  if (creditSummaryLoading) {
    totalCreditNode = <Spinner variant="process" size="xsmall" />;
  } else if (renderError) {
    totalCreditNode = <Button variant="slim" endIcon={<IconRefresh16 />} onClick={() => refetch()}>
        Retry
      </Button>;
  } else {
    totalCreditNode = <Text setting="body-large" as="span">
        {formatMoney(totalCreditAvailable.value, {
        inCents: true
      })}
      </Text>;
  }
  return <Box maxWidth="550px">
      <Text setting="title-large" spacingBottom>
        Account Credit
      </Text>
      <Box>
        <Text setting="body-large" as="span">
          Credit balance:{' '}
        </Text>
        {totalCreditNode}
      </Box>
      <Text setting="body-medium">
        Any credit available is shared with all members on the account and will
        be applied towards your next purchase.
      </Text>
    </Box>;
};